export default __webpack_public_path__ + "static/filtering-df0adca42d16c19406061a8013df9ba4.svg";